class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this._facetSubmitTimer = null;
    this.scheduleFacetSubmit = (event) => {
      if (this._facetSubmitTimer) clearTimeout(this._facetSubmitTimer);
      this._facetSubmitTimer = window.setTimeout(() => {
        this._facetSubmitTimer = null;
        this.onSubmitHandler(event);
      }, 350);
    };
    this.cancelScheduledFacetSubmit = () => {
      if (this._facetSubmitTimer) {
        clearTimeout(this._facetSubmitTimer);
        this._facetSubmitTimer = null;
      }
    };

    const facetForm = this.querySelector('form');
    if (facetForm) {
      const onFormChange = this.scheduleFacetSubmit.bind(this);
      facetForm.addEventListener('input', onFormChange);
      facetForm.addEventListener('change', onFormChange);
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document
      .querySelectorAll(
        'facet-remove a[href], a.active-facets__button-remove[href], a.skipp-plp-brand-filter__chip[href]'
      )
      .forEach((element) => {
        element.classList.toggle('disabled', disable);
        if (disable) {
          element.setAttribute('aria-disabled', 'true');
        } else {
          element.removeAttribute('aria-disabled');
        }
      });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const productGridWrap = document.getElementById('ProductGridContainer');
    if (productGridWrap) {
      productGridWrap._skippPlpRunGen = (productGridWrap._skippPlpRunGen || 0) + 1;
      delete productGridWrap.dataset.skippPlpSortInFlight;
      productGridWrap.classList.add('skipp-plp-grid-loading');
      const collectionForLoading = productGridWrap.querySelector('.collection');
      if (collectionForLoading) {
        collectionForLoading.classList.add('loading');
      }
    }
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
    document.querySelectorAll('.skipp-desktop-product-count-sync').forEach((el) => {
      el.classList.add('loading');
    });

    sections.forEach((section) => {
      const query = searchParams
        ? `section_id=${section.section}&${searchParams}`
        : `section_id=${section.section}`;
      const url = `${window.location.pathname}?${query}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (!sections.length) {
      FacetFiltersForm.clearFacetFetchErrorState();
    }

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static clearFacetFetchErrorState() {
    const productGridWrap = document.getElementById('ProductGridContainer');
    if (productGridWrap) {
      productGridWrap.classList.remove('skipp-plp-grid-loading');
      const collectionForLoading = productGridWrap.querySelector('.collection');
      if (collectionForLoading) collectionForLoading.classList.remove('loading');
    }
    document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    ).forEach((spinner) => spinner.classList.add('hidden'));
    document.querySelectorAll('.skipp-desktop-product-count-sync').forEach((el) => {
      el.classList.remove('loading');
    });
    ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.classList.remove('loading');
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        try {
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        } catch (_e) {
          FacetFiltersForm.clearFacetFetchErrorState();
        }
      })
      .catch(() => {
        FacetFiltersForm.clearFacetFetchErrorState();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const cached = FacetFiltersForm.filterData.find(filterDataUrl);
    if (!cached) return;
    const html = cached.html;
    try {
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    } catch (_e) {
      FacetFiltersForm.clearFacetFetchErrorState();
    }
  }

  static applyFromFacetHref(href) {
    if (!href || href === '#' || href.indexOf('javascript:') === 0) return;

    const wrap = document.getElementById('ProductGridContainer');
    if (wrap) {
      wrap._skippPlpRunGen = (wrap._skippPlpRunGen || 0) + 1;
      delete wrap.dataset.skippPlpSortInFlight;
    }

    FacetFiltersForm.toggleActiveFacets();

    let searchParams = '';
    try {
      const url = new URL(href, window.location.href);
      searchParams = url.search.length > 1 ? url.search.slice(1) : '';
    } catch (_e) {
      const q = href.indexOf('?');
      searchParams = q === -1 ? '' : href.slice(q + 1);
    }

    if (!searchParams) {
      FacetFiltersForm.filterData = [];
      document.querySelectorAll('facet-filters-form').forEach((facetFormEl) => {
        if (typeof facetFormEl.cancelScheduledFacetSubmit === 'function') {
          facetFormEl.cancelScheduledFacetSubmit();
        }
      });
    }

    FacetFiltersForm.renderPage(searchParams);
  }

  static resolveFacetNavLink(target) {
    if (!(target instanceof Element)) return null;

    const direct = target.closest(
      'facet-remove a[href], a.active-facets__button-remove[href], a.active-facets__button[href], a.mobile-facets__clear-all[href], a.mobile-facets__clear[href], a.skipp-plp-brand-filter__chip[href]'
    );
    if (direct) return direct;

    const wrapper = target.closest('facet-remove');
    return wrapper ? wrapper.querySelector('a[href]') : null;
  }

  static handleFacetNavInteraction(event) {
    const link = FacetFiltersForm.resolveFacetNavLink(event.target);
    if (!link) return false;
    if (link.classList.contains('disabled') || link.getAttribute('aria-disabled') === 'true') return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (typeof event.button === 'number' && event.button !== 0) return false;

    const href = link.getAttribute('href');
    if (!href || href === '#' || href.indexOf('javascript:') === 0) return false;

    event.preventDefault();
    event.stopPropagation();
    FacetFiltersForm.applyFromFacetHref(href);
    return true;
  }

  static renderProductGridContainer(html) {
    const preservedScroll =
      typeof window.scrollY === 'number' ? window.scrollY : window.pageYOffset || 0;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const remoteGrid = parsed.getElementById('ProductGridContainer');
    const localGrid = document.getElementById('ProductGridContainer');
    if (!remoteGrid || !localGrid) return;

    localGrid.innerHTML = remoteGrid.innerHTML;

    localGrid.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });

    const splitPresent = Boolean(document.querySelector('[data-skipp-collection-split]'));
    if (!splitPresent && preservedScroll > 0) {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
          window.scrollTo(0, Math.min(preservedScroll, maxY));
        });
      });
    }
  }

  static renderProductCount(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const countSource =
      doc.getElementById('ProductCount') || doc.getElementById('ProductCountDesktop');
    const countHtml = countSource ? countSource.innerHTML : '';

    try {
      if (countHtml) {
        const container = document.getElementById('ProductCount');
        if (container) {
          container.innerHTML = countHtml;
          container.classList.remove('loading');
        }
        const containerDesktop = document.getElementById('ProductCountDesktop');
        if (containerDesktop) {
          containerDesktop.innerHTML = countHtml;
          containerDesktop.classList.remove('loading');
        }
        document.querySelectorAll('.skipp-desktop-product-count-sync').forEach((el) => {
          el.innerHTML = countHtml;
          el.classList.remove('loading');
        });
      }
    } finally {
      const gridWrapDone = document.getElementById('ProductGridContainer');
      if (gridWrapDone) {
        gridWrapDone.classList.remove('skipp-plp-grid-loading');
      }
      document.querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
      ).forEach((spinner) => spinner.classList.add('hidden'));

      document.querySelectorAll('#ProductGridContainer .collection').forEach((c) =>
        c.classList.remove('loading')
      );
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event && event.target) {
      const jsFilter = event.target.closest('.js-filter');
      const closestJSFilterID = jsFilter ? jsFilter.id : null;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const doc = html instanceof Document ? html : null;
    if (!doc) return;

    const remoteMobile = doc.getElementById('skipp-plp-active-facets');
    const localMobile = document.getElementById('skipp-plp-active-facets');
    if (localMobile) {
      if (remoteMobile) {
        localMobile.outerHTML = remoteMobile.outerHTML;
      } else {
        localMobile.remove();
      }
    } else if (remoteMobile) {
      const grid = document.getElementById('ProductGridContainer');
      const brandFilter = grid?.querySelector('[data-skipp-plp-brand-filter], .skipp-plp-brand-filter');
      if (grid) {
        if (brandFilter) {
          brandFilter.before(remoteMobile);
        } else {
          grid.prepend(remoteMobile);
        }
      }
    }

    const remoteDesktop = doc.querySelector('.active-facets-desktop');
    const localDesktop = document.querySelector('.active-facets-desktop');
    if (remoteDesktop && localDesktop) {
      localDesktop.innerHTML = remoteDesktop.innerHTML;
    }

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const remote = html.querySelector(selector);
      const local = document.querySelector(selector);
      if (!remote || !local) return;
      local.innerHTML = remote.innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    if (productGrid?.dataset?.id) {
      return [{ section: productGrid.dataset.id }];
    }
    const gridWrap = document.getElementById('ProductGridContainer');
    const sectionFromWrap = gridWrap?.getAttribute('data-skipp-plp-section-id');
    if (sectionFromWrap) {
      return [{ section: sectionFromWrap }];
    }
    const filtersAside = document.getElementById('main-collection-filters');
    if (filtersAside?.dataset?.id) {
      return [{ section: filtersAside.dataset.id }];
    }
    return [];
  }

  static submitMobileFacetsForm(event) {
    const form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return false;

    const facetFormEl = form.closest('facet-filters-form');
    if (!facetFormEl) return false;

    if (typeof facetFormEl.cancelScheduledFacetSubmit === 'function') {
      facetFormEl.cancelScheduledFacetSubmit();
    }

    const searchParams = facetFormEl.createSearchParams(form);
    FacetFiltersForm.renderPage(searchParams, event);
    return true;
  }

  static closeMobileFacetsDrawer() {
    const details = document.querySelector('details.mobile-facets__disclosure');
    const summary = details?.querySelector('summary.mobile-facets__open-wrapper');
    if (summary && details?.hasAttribute('open')) {
      summary.click();
    }
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const target = event.target;
    const targetForm = target && target.closest ? target.closest('form') : null;
    if (!targetForm) return;

    const isMobileCheckbox =
      target.classList &&
      (target.classList.contains('mobile-facets__checkbox') ||
        target.classList.contains('mweb-gender-radio__input') ||
        target.classList.contains('mweb-sort-sheet__input'));
    if (isMobileCheckbox) {
      const searchParams = this.createSearchParams(targetForm);
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = targetForm.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const link =
      (event.currentTarget && event.currentTarget.closest && event.currentTarget.closest('a[href]')) ||
      (event.currentTarget && event.currentTarget.href ? event.currentTarget : null);
    if (!link || !link.href) return;
    FacetFiltersForm.applyFromFacetHref(link.href);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
window.FacetFiltersForm = FacetFiltersForm;

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.textInputs = Array.from(this.querySelectorAll('input.field__input'));
    this.rangeInputs = Array.from(this.querySelectorAll('input[type="range"].price-range-slider__input'));
    this.fillEl = this.querySelector('[data-price-range-fill]');
    this.valueEl = this.querySelector('[data-price-range-value]');
    this.sliderRoot = this.querySelector('[data-price-range-slider]');

    this.textInputs.forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });

    this.rangeInputs.forEach((element) => {
      element.addEventListener('input', this.onSliderInput.bind(this));
      element.addEventListener('change', this.onSliderInput.bind(this));
    });

    this.setMinAndMaxValues();
    this.syncSliderFromText();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.syncSliderFromText();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const minInput = this.textInputs[0];
    const maxInput = this.textInputs[1];
    if (!minInput || !maxInput) return;
    const rangeMin = Number(this.sliderRoot?.getAttribute('data-range-min')) || 0;
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', rangeMin);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  onSliderInput() {
    if (!this.sliderRoot || this.rangeInputs.length < 2 || this.textInputs.length < 2) return;

    const rangeMax = Number(this.sliderRoot.getAttribute('data-range-max')) || 0;
    const minRange = this.sliderRoot.querySelector('.price-range-slider__input--min');
    const maxRange = this.sliderRoot.querySelector('.price-range-slider__input--max');
    if (!minRange || !maxRange) return;
    const rangeMin =
      Number(this.sliderRoot.getAttribute('data-range-min')) || Number(minRange.getAttribute('min')) || 0;

    let minVal = Number(minRange.value);
    let maxVal = Number(maxRange.value);

    if (minVal > maxVal) {
      const active = document.activeElement;
      if (active === minRange) {
        maxVal = minVal;
        maxRange.value = String(maxVal);
      } else {
        minVal = maxVal;
        minRange.value = String(minVal);
      }
    }

    minVal = Math.max(rangeMin, Math.min(minVal, rangeMax));
    maxVal = Math.max(rangeMin, Math.min(maxVal, rangeMax));

    // Update hidden text inputs (used by Shopify facet params)
    const minText = this.textInputs[0];
    const maxText = this.textInputs[1];
    minText.value = minVal > rangeMin ? String(minVal) : '';
    maxText.value = maxVal < rangeMax ? String(maxVal) : '';

    // Trigger facet form update
    minText.dispatchEvent(new Event('input', { bubbles: true }));

    this.updateSliderUI(minVal, maxVal, rangeMax);
  }

  syncSliderFromText() {
    if (!this.sliderRoot || this.rangeInputs.length < 2 || this.textInputs.length < 2) return;
    const rangeMax = Number(this.sliderRoot.getAttribute('data-range-max')) || 0;
    const minRange = this.sliderRoot.querySelector('.price-range-slider__input--min');
    const maxRange = this.sliderRoot.querySelector('.price-range-slider__input--max');
    if (!minRange || !maxRange) return;
    const rangeMin =
      Number(this.sliderRoot.getAttribute('data-range-min')) || Number(minRange.getAttribute('min')) || 0;

    const minTextRaw = this.textInputs[0].value;
    const minTextVal = minTextRaw === '' ? rangeMin : Number(minTextRaw || rangeMin);
    const maxTextVal = this.textInputs[1].value === '' ? rangeMax : Number(this.textInputs[1].value || rangeMax);

    minRange.value = String(Math.max(rangeMin, Math.min(minTextVal, rangeMax)));
    maxRange.value = String(Math.max(rangeMin, Math.min(maxTextVal, rangeMax)));

    this.updateSliderUI(Number(minRange.value), Number(maxRange.value), rangeMax);
  }

  updateSliderUI(minVal, maxVal, rangeMax) {
    if (this.fillEl && rangeMax > 0) {
      const rangeMin = Number(this.sliderRoot?.getAttribute('data-range-min')) || 0;
      const span = Math.max(1, rangeMax - rangeMin);
      const left = ((minVal - rangeMin) / span) * 100;
      const right = 100 - ((maxVal - rangeMin) / span) * 100;
      this.fillEl.style.left = `${left}%`;
      this.fillEl.style.right = `${right}%`;
    }

    if (this.valueEl && this.sliderRoot) {
      const symbol = this.sliderRoot.getAttribute('data-currency-symbol') || '';
      const nf = new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 });
      const maxText = maxVal >= rangeMax ? `${symbol}${nf.format(rangeMax)}+` : `${symbol}${nf.format(maxVal)}`;
      const minText = `${symbol}${nf.format(minVal)}`;
      this.valueEl.textContent = `${minText} - ${maxText}`;
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  connectedCallback() {
    const facetLink = this.querySelector('a');
    if (!facetLink || facetLink.dataset.skippFacetLinkReady === 'true') return;
    facetLink.dataset.skippFacetLinkReady = 'true';
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      FacetFiltersForm.applyFromFacetHref(facetLink.href);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/** Reliable facet navigation for pills, Remove all, and brand chips (survives AJAX re-render). */
let skippLastFacetTouchNavAt = 0;

document.addEventListener(
  'click',
  (event) => {
    if (Date.now() - skippLastFacetTouchNavAt < 700) {
      if (FacetFiltersForm.resolveFacetNavLink(event.target)) {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }
    FacetFiltersForm.handleFacetNavInteraction(event);
  },
  true
);

document.addEventListener(
  'touchend',
  (event) => {
    if (event.changedTouches?.length !== 1) return;
    const touch = event.changedTouches[0];
    const target = document.elementFromPoint(touch.clientX, touch.clientY);
    if (!target) return;
    const synthetic = {
      target,
      preventDefault: () => event.preventDefault(),
      stopPropagation: () => event.stopPropagation(),
      metaKey: false,
      ctrlKey: false,
      shiftKey: false,
      altKey: false,
      button: 0,
    };
    if (FacetFiltersForm.handleFacetNavInteraction(synthetic)) {
      skippLastFacetTouchNavAt = Date.now();
      event.preventDefault();
    }
  },
  { capture: true, passive: false }
);

// Mobile web: fixed bottom "Sort / Filters" bar helpers
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-mweb-facets-action]');
  if (!trigger) return;

  const action = trigger.getAttribute('data-mweb-facets-action');
  const menuDrawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
  const summary = menuDrawer?.querySelector('summary.mobile-facets__open-wrapper');
  if (!summary) return;

  // Mark which mode we want inside the sheet (used by CSS)
  const mode = action === 'sort' ? 'sort' : action === 'gender' ? 'gender' : 'filters';
  document.body.dataset.mwebFacetsMode = mode;

  const candidates = Array.from(menuDrawer.querySelectorAll('[data-mweb-filter-target]'));
  const genderTab = candidates.find((el) => (el.textContent || '').trim().toLowerCase().includes('gender'));
  const genderIdx = genderTab?.getAttribute('data-mweb-filter-target');

  if (mode === 'gender') {
    if (genderIdx) document.body.dataset.mwebActiveFilter = genderIdx;
  }

  if (mode === 'filters') {
    // If Gender is first (or previously selected), move to first non-gender to avoid blank panel.
    const firstNonGender = candidates.find((el) => !(el.textContent || '').trim().toLowerCase().includes('gender'));
    const idx = firstNonGender?.getAttribute('data-mweb-filter-target');
    if (idx) document.body.dataset.mwebActiveFilter = idx;
  }

  // Open the drawer/sheet
  summary.click();

  if (mode === 'filters' || mode === 'gender') {
    window.setTimeout(() => {
      const idx = document.body.dataset.mwebActiveFilter || '1';
      const target =
        menuDrawer.querySelector(`[data-mweb-filter-target="${idx}"]`) ||
        menuDrawer.querySelector('[data-mweb-filter-target]');
      if (target) target.click();
    }, 50);
  }

  if (action === 'sort') {
    // Once open, bring Sort into view
    window.setTimeout(() => {
      const sortDetails = menuDrawer.querySelector('.mobile-facets__details--sort');
      if (sortDetails) {
        sortDetails.scrollIntoView({ block: 'start' });
        const select = sortDetails.querySelector('select');
        if (select) select.focus({ preventScroll: true });
      }
    }, 250);
  }
});

// Toggle helpers: when the mobile facets sheet opens, hide competing sticky UI
function syncMwebFacetsOpenState() {
  const details = document.querySelector('details.mobile-facets__disclosure');
  if (!details) return;
  const isOpen = details.hasAttribute('open');
  document.body.classList.toggle('mweb-facets-open', isOpen);

  // Lock background scroll on mweb while the sheet is open
  const isMweb = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  if (!isMweb) return;

  if (isOpen) {
    if (!document.body.dataset.mwebScrollLocked) {
      const y = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.mwebScrollLocked = '1';
      document.body.dataset.mwebScrollY = String(y);
      document.body.style.position = 'fixed';
      document.body.style.top = `-${y}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
  } else if (document.body.dataset.mwebScrollLocked) {
    const y = Number(document.body.dataset.mwebScrollY || '0');
    delete document.body.dataset.mwebScrollLocked;
    delete document.body.dataset.mwebScrollY;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, y);
    delete document.body.dataset.mwebFacetsMode;
  }
}

// `toggle` on <details> isn't reliably bubbled across all browsers, so use capture + mutation.
document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;
    if (!(details instanceof HTMLElement)) return;
    if (!details.matches('details.mobile-facets__disclosure')) return;
    syncMwebFacetsOpenState();
  },
  true
);

document.addEventListener('DOMContentLoaded', () => {
  syncMwebFacetsOpenState();

  const details = document.querySelector('details.mobile-facets__disclosure');
  if (!details) return;

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((m) => m.type === 'attributes' && m.attributeName === 'open')) {
      syncMwebFacetsOpenState();
      const form = document.querySelector('form#FacetFiltersFormMobile');
      if (form) {
        const idx = document.body.dataset.mwebActiveFilter || '1';
        setActiveMwebFilter(idx, form);
      }
    }
  });

  observer.observe(details, { attributes: true, attributeFilter: ['open'] });

  // Re-apply active panel after AJAX re-render
  const mobileForm = document.querySelector('form#FacetFiltersFormMobile');
  if (mobileForm) {
    const formObserver = new MutationObserver(() => {
      const idx = document.body.dataset.mwebActiveFilter || '1';
      setActiveMwebFilter(idx, mobileForm);
    });
    formObserver.observe(mobileForm, { childList: true, subtree: true });
  }
});

// When a mobile filter group opens, close others (tab-like behavior)
function setActiveMwebFilter(idx, root) {
  const scope = root || document;
  const buttons = scope.querySelectorAll('[data-mweb-filter-target]');
  const panels = scope.querySelectorAll('[data-mweb-filter-panel]');

  buttons.forEach((btn) => {
    const isActive = btn.getAttribute('data-mweb-filter-target') === String(idx);
    btn.classList.toggle('is-active', isActive);
    btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  panels.forEach((panel) => {
    const isActive = panel.getAttribute('data-mweb-filter-panel') === String(idx);
    panel.classList.toggle('is-active', isActive);
  });
}

// Switch left category -> right panel (mweb filters mode)
document.addEventListener(
  'click',
  (event) => {
    const btn = event.target.closest('[data-mweb-filter-target]');
    if (!btn) return;
    // Left filter tabs are anchors (avoid navigation)
    if (btn.matches('a')) event.preventDefault();
    const idx = btn.getAttribute('data-mweb-filter-target');
    if (!idx) return;
    document.body.dataset.mwebActiveFilter = idx;
    const form = btn.closest('form#FacetFiltersFormMobile');
    setActiveMwebFilter(idx, form || document);
  },
  true
);

// Desktop: close sort dropdown after selecting an option
document.addEventListener(
  'change',
  (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.name !== 'sort_by') return;
    if (!input.closest('.desktop-sortbar__menu')) return;

    const details = input.closest('details.desktop-sortbar__dropdown');
    if (details) details.removeAttribute('open');
  },
  true
);

// Click outside sheet to close (mweb)
document.addEventListener(
  'click',
  (event) => {
    if (!document.body.classList.contains('mweb-facets-open')) return;
    const overlay = event.target.closest('.mobile-facets');
    if (!overlay) return;
    if (event.target.closest('.mobile-facets__inner')) return;

    const summary = document.querySelector('details.mobile-facets__disclosure > summary.mobile-facets__open-wrapper');
    if (summary) summary.click();
  },
  true
);

// Mobile Apply / Close — submit filters explicitly (Apply only closed the drawer before).
document.addEventListener(
  'click',
  (event) => {
    const applyBtn = event.target.closest('[data-mweb-facets-apply]');
    if (applyBtn) {
      event.preventDefault();
      event.stopPropagation();
      FacetFiltersForm.submitMobileFacetsForm(event);
      FacetFiltersForm.closeMobileFacetsDrawer();
      return;
    }

    const closeBtn = event.target.closest('[data-mweb-facets-close]');
    if (closeBtn) {
      event.preventDefault();
      event.stopPropagation();
      FacetFiltersForm.closeMobileFacetsDrawer();
    }
  },
  true
);

// Backup: ensure mobile facet input changes always trigger AJAX (survives drawer / MenuDrawer quirks).
document.addEventListener(
  'change',
  (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    const form = target.closest('#FacetFiltersFormMobile');
    if (!form) return;

    const isFacetInput =
      target.classList.contains('mobile-facets__checkbox') ||
      target.classList.contains('mweb-gender-radio__input') ||
      target.classList.contains('mweb-sort-sheet__input') ||
      target.name === 'sort_by';

    if (!isFacetInput) return;

    const facetFormEl = form.closest('facet-filters-form');
    if (!facetFormEl || typeof facetFormEl.scheduleFacetSubmit !== 'function') return;

    facetFormEl.scheduleFacetSubmit(event);
  },
  true
);
